const random = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min)) + min;

export const randomVisibilityData = () => {
  let data = [Math.random() * 100];

  for (let i = 0; i < 20; i++) {
    data.push(Math.min(100, Math.max(0, data[i] + random(-20, 20))));
  }

  return data;
};

export const timestampToRelativeTime = (time: number) => {
  const current = new Date().getTime();

  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  const elapsed = current - time;

  if (elapsed < msPerMinute) return Math.round(elapsed / 1000) + "s ago";
  else if (elapsed < msPerHour)
    return Math.round(elapsed / msPerMinute) + "min ago";
  else if (elapsed < msPerDay) return Math.round(elapsed / msPerHour) + "h ago";
  else if (elapsed < msPerMonth)
    return Math.round(elapsed / msPerDay) + "d ago";
  else if (elapsed < msPerYear)
    return Math.round(elapsed / msPerMonth) + "m ago";
  else return Math.round(elapsed / msPerYear) + "y ago";
};

export const randomElement = (array: any[]) =>
  array[Math.floor(Math.random() * array.length)];
